import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Nav, Navbar, Button } from "react-bootstrap";
import "../../style/contactPage/contactpage.scss";
import img1 from "../../assets/pexels-pixabay-326055.jpg";
import axios from "axios";
import search from "../../assets/logo (2).svg";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import Footer from "../work/footer";
import { UserContext } from "../../use_context";

const About = () => {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  // const [officeData, setOfficeData] = useState(null);
  const { officeData, setOfficeData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [testimonials, setTestimonials] = useState([]);
  const [idx, setIdx] = useState(0);

  const goPrev = () =>
    setIdx((i) => (i === 0 ? testimonials.length - 1 : i - 1)); // Fix for prev index
  const goNext = () =>
    setIdx((i) => (i === testimonials.length - 1 ? 0 : i + 1)); // Fix for next index

  // Destructure the current testimonial based on idx
  const currentTestimonial = testimonials[idx] || {};
  const { testimonial_text, testimonial_text_1, testimonial_desc } =
    currentTestimonial;

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };

  useEffect(() => {
    if (officeData?.testimonial_repeater?.length) {
      setTestimonials(officeData.testimonial_repeater);
    }
  }, [officeData]);

  useEffect(() => {
    if (officeData) {
      setLoading(false); // <== This fixes the loader hang issue
      return;
    }
    const fetchMediaUrl = async (id) => {
      try {
        const response = await axios.get(
          `https://infoglans.com/search/wp-json/wp/v2/media/${id}`
        );
        return response.data.source_url;
      } catch (error) {
        console.error("Error fetching media:", error);
        return null;
      }
    };

    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://infoglans.com/search/wp-json/wp/v2/pages/156"
        );
        const data = response.data;
        const office = data.acf.office;

        // console.log(officeData.publications);
        // Fetch publications
        const publications = office.publications || [];
        const updatedPublications = await Promise.all(
          publications.map(async (pub) => {
            const imageUrl = await fetchMediaUrl(pub.publications_img);
            const pdfUrl = await fetchMediaUrl(pub.publications_pdf);
            return {
              ...pub,
              publications_img_url: imageUrl,
              publications_pdf: pdfUrl,
            };
          })
        );

        // Fetch office image
        const officeImgUrl = await fetchMediaUrl(office.office_img);

        // ✅ Fetch all client logo URLs
        const clientLogos = office.add_clients_sections_img || [];
        const clientLogoUrls = await Promise.all(
          clientLogos.map(async (logoObj) => {
            const id = logoObj.add_clients_sections_logo;
            return id ? await fetchMediaUrl(id) : null;
          })
        );

        setOfficeData({
          ...office,
          office_img_url: officeImgUrl,
          publications: updatedPublications,
          client_logos_url: clientLogoUrls.filter(Boolean), // Remove nulls
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading || !officeData) {
    return (
      <div className="loader-mask">
        <div className="loader"></div>
      </div>
    );
  }

  // console.log("officeData", officeData.leadership_repeater);

  const accoladesToShow = showAll
    ? officeData.accolades
    : officeData.accolades?.slice(0, 6);
  return (
    <div>
      <div className="about-section py-5">
        <header className="fixed header-transparent wide-container bg-white">
          <Container className="navigation-wrapper">
            <Navbar expand="lg" className="nav-row first-row">
              <Link to="/homepage" className="text-decoration-none">
                <Navbar.Brand className="brand-logo">
                  <img
                    src={search}
                    width="178px"
                    height="33px"
                    alt="React Bootstrap logo"
                  />
                </Navbar.Brand>
              </Link>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={handleOffcanvasToggle}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="end"
                className="office-offcanvas-custom"
                show={offcanvasOpen}
                onHide={handleOffcanvasClose}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Navbar.Collapse id="basic-navbar-nav" className="ms-auto">
                    <Nav className="menu list-inline custom-ml" id="menu">
                      {/* <NavDropdown.Item href="#action3"> */}
                      <Nav.Link
                        as={Link}
                        to="/Office"
                        className={`${
                          offcanvasOpen ? "white-text" : "black-text"
                        } active`}
                      >
                        Office
                      </Nav.Link>
                      {/* </NavDropdown.Item> */}
                      {/* <NavDropdown.Item href="#action3"> */}
                      <Nav.Link
                        as={Link}
                        to="/Works"
                        className={offcanvasOpen ? "white-text" : "black-text"}
                        // href="/Works"
                      >
                        Works
                      </Nav.Link>
                      {/* </NavDropdown.Item> */}
                      {/* <NavDropdown.Item href="#action3"> */}
                      <Nav.Link
                        as={Link}
                        to="/News"
                        className={offcanvasOpen ? "white-text" : "black-text"}
                        // href="/News"
                      >
                        News
                      </Nav.Link>
                      {/* </NavDropdown.Item> */}
                      {/* <NavDropdown.Item href="#action3"> */}
                      <Nav.Link
                        as={Link}
                        to="/Contact"
                        className={offcanvasOpen ? "white-text" : "black-text"}
                        // href="/Contact"
                      >
                        Contact
                      </Nav.Link>
                      {/* </NavDropdown.Item> */}
                    </Nav>
                  </Navbar.Collapse>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Navbar>
          </Container>
        </header>
        <Container>
          <div className="about-align">
            <Row className="mb-5 office-m-t">
              <Col md={3}>
                <h4 className="about-title">{officeData.office_title}</h4>
              </Col>
              <Col md={9}>
                <div
                  className="about-desc"
                  dangerouslySetInnerHTML={{ __html: officeData.office_desc }}
                />
              </Col>
            </Row>

            <Row className="mb-5">
              <Col md={3}>
                <h4 className="about-title">{officeData.team_titel}</h4>
              </Col>
              <Col md={9}>
                <div
                  className="about-desc"
                  dangerouslySetInnerHTML={{ __html: officeData.team_desc }}
                />
              </Col>
            </Row>
            <Row>
              {officeData.office_img && (
                //   <img src={img1} alt="Office" className="img-fluid mt-3" />
                <img
                  src={officeData.office_img_url}
                  alt="Office"
                  className="img-fluid mt-3"
                />
              )}
            </Row>

            <Row
              className="mb-2 office-12"
              // onClick={() => (window.location.href = "/portfolio/kapil-bhalla")}
              style={{ cursor: "pointer" }}
            >
              <Col md={3}>
                <h4 className="about-title mb-4">Leadership</h4>
              </Col>
            </Row>
            {officeData?.leadership_repeater?.length > 0 && (
              <>
                {officeData.leadership_repeater
                  .reduce((rows, item, index) => {
                    if (index % 2 === 0) rows.push([item]); // Start a new row
                    else rows[rows.length - 1].push(item); // Add to current row
                    return rows;
                  }, [])
                  .map((pair, rowIndex) => (
                    <Row key={rowIndex} className="mb-4">
                      {pair.map((item, colIndex) => (
                        <Col md={6} key={colIndex}>
                          <Link
                            to={`/leadership/${item.leadership_name
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                            state={{ leader: item }}
                            style={{ textDecoration: "none" }}
                          >
                            <h6
                              className="office-leadership-semibold"
                              style={{ cursor: "pointer", color: "#333333" }}
                            >
                              {item.leadership_name}
                            </h6>
                          </Link>
                          <p className="office-leadership-regular">
                            {item.leadership_desc}
                          </p>
                        </Col>
                      ))}
                    </Row>
                  ))}
              </>
            )}
            <Row className="mt-5">
              <Col md={4}>
                <h4 className="about-title">{officeData.internal_teams}</h4>
              </Col>
              <Col md={8}>
                <div
                  className="about-desc"
                  dangerouslySetInnerHTML={{
                    __html: officeData.internal_teams_desc,
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md={4}>
                <h4 className="about-title">{officeData.consultants}</h4>
              </Col>
              <Col md={8}>
                <div
                  className="about-desc"
                  dangerouslySetInnerHTML={{
                    __html: officeData.consultants_desc,
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md={4}>
                <h4 className="about-title">{officeData.collaborations}</h4>
              </Col>
              <Col md={8}>
                <div
                  className="about-desc"
                  dangerouslySetInnerHTML={{
                    __html: officeData.collaborations_desc,
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md={12}>
                <h4 className="about-title">
                  {officeData.add_clients_sections_title}
                </h4>
              </Col>

              {/* Logo Grid Starts */}
              <Col md={12}>
                <Row className="g-5">
                  {officeData.client_logos_url?.map((url, index) => (
                    <Col key={index} xs={6} sm={4} md={2}>
                      <img
                        src={url}
                        alt={`Client Logo ${index + 1}`}
                        className="img-fluid mt-5"
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "auto",
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md={12}>
                {/* Check if officeData.testimonial_title exists */}
                {officeData?.testimonial_title && (
                  <h4 className="about-title">
                    {officeData.testimonial_title}
                  </h4>
                )}
              </Col>
              <Container className="py-5">
                <Row className="justify-content-center">
                  <Col xs={12} md={11} lg={10}>
                    <Row className="align-items-center">
                      {/* Left Arrow */}
                      <Col xs={2} className="text-center">
                        <Button
                          // style={{
                          //   borderRadius: "100%",
                          //   padding: "10px",
                          //   border: "1px solid grey",
                          // }}
                          className="btn-test"
                          variant="link"
                          onClick={goPrev}
                        >
                          <BiChevronLeft size={32} />
                        </Button>
                      </Col>

                      {/* Testimonial Content */}
                      <Col xs={8} className="text-center">
                        {/* Check if testimonial data exists */}
                        {testimonial_text && testimonial_text_1 && (
                          <h5 className="mb-3">
                            {testimonial_text} -{" "}
                            <span className="text-primary">
                              {testimonial_text_1}
                            </span>
                          </h5>
                        )}

                        {testimonial_desc && (
                          <div
                            className="mt-3 text-secondary"
                            dangerouslySetInnerHTML={{
                              __html: testimonial_desc,
                            }}
                          />
                        )}
                      </Col>

                      {/* Right Arrow */}
                      <Col xs={2} className="text-center">
                        <Button
                          className="btn-test"
                          variant="link"
                          onClick={goNext}
                        >
                          <BiChevronRight size={32} />
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </Row>

            <Row className="mt-5">
              <Col md={12}>
                <h4 className="about-title mb-4">Accolades</h4>

                <div
                  className="accolades-vertical-scroll"
                  style={{
                    maxHeight: showAll ? "800px" : "250px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                    paddingRight: "10px",
                    boxSizing: "border-box",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                  }}
                >
                  {officeData.accolades
                    ?.reduce((rows, item, index) => {
                      if (index % 2 === 0) rows.push([item]);
                      else rows[rows.length - 1].push(item);
                      return rows;
                    }, [])
                    .map((pair, rowIndex) => (
                      <Row key={rowIndex} className="mb-3">
                        {pair.map((item, colIndex) => (
                          <Col key={colIndex} md={6}>
                            <p className="font-h-w-2">
                              {item.accolades_sub_title}
                            </p>
                            <p>{item.accolades_desc}</p>
                          </Col>
                        ))}
                      </Row>
                    ))}
                </div>

                {/* Button stays below scrollable area */}
                {officeData.accolades?.length > 6 && (
                  <Button
                    variant="primary"
                    className="mt-3 btn-accolades"
                    onClick={() => setShowAll((prev) => !prev)}
                  >
                    {showAll ? "View Less" : "View More"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default About;
